import React from 'react';
import { Box, Typography } from '@mui/material';
import { op } from 'theme';

const NewsCard = ({ icon, title, description, date, author }) => {
  return (
    <Box
      sx={{
        backgroundColor: op.bg.surface,
        border: `1px solid ${op.border}`,
        borderRadius: '10px',
        padding: '16px',
        transition: 'border-color 150ms ease-out',
        '&:hover': {
          borderColor: 'rgba(157,0,255,.6)',
        }
      }}
    >
      {/* Icono + fecha */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
        <Box
          sx={{
            width: '40px',
            height: '40px',
            backgroundColor: op.violet.deep,
            borderRadius: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '20px',
            flexShrink: 0,
          }}
        >
          {icon || '📰'}
        </Box>
        <Typography
          sx={{
            color: 'text.secondary',
            fontSize: '12px',
            fontWeight: 600,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
          }}
        >
          {date}
        </Typography>
      </Box>

      {/* Título */}
      <Typography
        variant="h4"
        component="h3"
        sx={{ marginBottom: '8px', lineHeight: 1.3 }}
      >
        {title}
      </Typography>

      {/* Descripción */}
      <Typography
        variant="body2"
        sx={{ color: 'text.secondary', marginBottom: '16px', lineHeight: 1.6 }}
      >
        {description}
      </Typography>

      {/* Autor */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          paddingTop: '12px',
          borderTop: `1px solid ${op.border}`,
        }}
      >
        <Box
          sx={{
            width: '32px',
            height: '32px',
            backgroundColor: op.violet.deep,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '14px',
            fontWeight: 700,
            color: '#FFFFFF',
            flexShrink: 0,
          }}
        >
          {author?.charAt(0) || 'O'}
        </Box>
        <Box>
          <Typography sx={{ color: 'text.primary', fontSize: '14px', fontWeight: 600 }}>
            {author}
          </Typography>
          <Typography sx={{ color: 'text.secondary', fontSize: '12px' }}>
            Organizador
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default NewsCard;
